import React, { useState } from 'react';
import clsx from 'clsx';
import axios from 'axios';
import { toast } from 'react-hot-toast';

import { BaseComponentProps } from '@utils/types/baseComponents';
import { postGenerateUploadUrlForContactForm } from '@api/landings/postGenerateUploadUrlForContactForm';

import styles from './styles.module.scss';

type Props = {
  email: string;
  onImagesUploaded: (
    images: {
      url: string;
      file: File;
    }[]
  ) => void;
} & BaseComponentProps;

const ImagesDropzone = (props: Props) => {
  const { email, onImagesUploaded, containerStyle } = props;
  const [selectedFiles, setSelectedFiles] = useState<File[]>([]);

  const handleFiles = async (files: FileList) => {
    const validFiles = Array.from(files).filter((file) =>
      file.type.startsWith('image/')
    );

    if (validFiles.length === 0) {
      toast.error('Please upload valid image files.');
      return;
    }

    setSelectedFiles(validFiles);

    const uploadedImageUrls: {
      url: string;
      file: File;
    }[] = [];

    for (const file of validFiles) {
      const {
        data: { uploadUrl },
      } = await postGenerateUploadUrlForContactForm({
        file_type: file.type,
        email,
      });

      await axios.put(uploadUrl, file, {
        headers: {
          'Content-Type': file.type,
        },
      });

      uploadedImageUrls.push({
        url: uploadUrl.split('?')[0],
        file,
      });
    }

    onImagesUploaded(uploadedImageUrls);
  };

  const handleDrop = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    handleFiles(event.dataTransfer.files);
  };

  const handleClick = () => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';
    input.multiple = true;
    input.onchange = (event: any) => {
      handleFiles(event.target.files);
    };
    input.click();
  };

  return (
    <div
      className={clsx([styles.dropzone, containerStyle])}
      onDrop={handleDrop}
      onClick={handleClick}
      onDragOver={(e) => e.preventDefault()}
    >
      + Add Photos
    </div>
  );
};

export default ImagesDropzone;
